import SpriteSymbol from "../../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.store/svg-sprite-loader@5.2.1/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-New_1",
  "use": "icon-New_1-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-New_1\"><path d=\"M102.4 558.353067h819.2a51.2 51.2 0 1 0 0-102.4H102.4a51.2 51.2 0 0 0 0 102.4z\" fill=\"#FFA000\" p-id=\"31567\" /><path d=\"M460.8 916.753067v-819.2a51.2 51.2 0 1 1 102.4 0v819.2a51.2 51.2 0 0 1-102.4 0z\" fill=\"#FFA000\" p-id=\"31568\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol